var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47.2 50.51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.43 50.51-13.18-21.84v9.97h3.04v11.87h-20.29v-11.87h2.9v-26.77h-2.9v-11.87h16.23l13.58 22.48v-10.61h-3.04v-11.87h20.43v11.87h-3.04v26.77h3.04v11.87z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31.31 48.99-15.58-25.96v17.13h3.04v8.83h-17.25v-8.83h2.9v-29.81h-2.9v-8.83h13.82l15.99 26.61v-17.78h-3.04v-8.83h17.39v8.83h-3.04v29.81h3.04v8.83z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.98 47.44v-5.7h2.93v-32.92h-2.93v-5.7h11.48l18.45 30.64v-24.94h-3.06v-5.7h14.25v5.7h-3.07v32.92h3.07v5.7h-11.9l-18.03-30.07v24.37h2.99v5.7z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/n.76ada07e102aa5d55a7ca86cf83b4584.svg";
export { ForwardRef as ReactComponent };